import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { MessageSquareWarning, X, Loader2, Send } from "lucide-react";

export const FeedbackWidget = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/feedback", { message, page: window.location.pathname });
      toast.success("Thank you! Your feedback has been sent.");
      setMessage("");
      setOpen(false);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Failed to send feedback");
    } finally { setBusy(false); }
  };

  return (
    <div className="fixed bottom-5 right-5 z-50">
      {open && (
        <form onSubmit={submit} data-testid="feedback-panel"
          className="mb-3 w-80 bg-white border border-[#E7E5E4] rounded-2xl shadow-2xl p-5">
          <div className="flex items-center justify-between">
            <h4 className="font-heading text-navy">Report an issue</h4>
            <button type="button" onClick={() => setOpen(false)} data-testid="feedback-close" className="text-[#A8A29E] hover:text-navy"><X className="w-4 h-4" /></button>
          </div>
          <p className="mt-1 text-xs text-[#78716C]">Spotted a bug or have a suggestion? It goes straight to the MBBC team, along with the page you're on.</p>
          <textarea data-testid="feedback-message" required rows={4} value={message} onChange={(e) => setMessage(e.target.value)}
            placeholder="Describe the issue or your feedback…"
            className="mt-3 w-full border border-[#E7E5E4] rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-teal/20 focus:border-teal" />
          <button type="submit" disabled={busy} data-testid="feedback-submit"
            className="mt-3 w-full bg-teal text-white rounded-full py-2.5 text-sm font-medium hover:bg-teal-dark flex items-center justify-center gap-2 disabled:opacity-60">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Send feedback
          </button>
        </form>
      )}
      <button onClick={() => setOpen(!open)} data-testid="feedback-toggle"
        className="ml-auto flex items-center gap-2 bg-navy text-white rounded-full pl-4 pr-5 py-3 shadow-xl hover:bg-navy-dark transition-colors text-sm font-medium">
        <MessageSquareWarning className="w-4 h-4 text-teal" /> Report an issue
      </button>
    </div>
  );
};
